import { useMemo } from "react";
import { queriesProfitAndLoss } from "@query";
import { useBookkeepingDateRange } from "../useBookkeepingDateRange";

export function useProfitAndLossQuery() {
  const { range } = useBookkeepingDateRange();

  const startTime = range.start.valueOf();
  const endTime = range.end.valueOf();

  const request = useMemo(
    () => ({ startDate: new Date(startTime), endDate: new Date(endTime) }),
    [startTime, endTime]
  );

  const query = queriesProfitAndLoss.getProfitAndLoss.useQuery(request);

  return { query, range };
}
